import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';

import { toast } from 'react-toastify';
import axios from 'axios';

import DiscountInput from '~/components/DiscountInput';
import { Space } from '~/designsystem/Fonts';
import CardCommissions from '~/components/ProPlan/Cards/CardCommissions';
import ShortCardPremiumPlan from '~/components/ProPlan/Cards/CardPremiumPlan/Short';
import api from '../../../../../services/api';

import ActiveMercadoPagoIcon from '../../../../../assets/icons/activeMercadoPago.svg';

// import CreditCardIcon from '../../../../../assets/icons/paymentmethods/creditcard.svg';
// import BoletIcon from '../../../../../assets/icons/paymentmethods/bolet.svg';
// import QrCodeIcon from '../../../../../assets/icons/paymentmethods/qrcode.svg';
// import LinkIcon from '../../../../../assets/icons/paymentmethods/link.svg';

import Header from '../Header';

import LoadingContainer from '../../../../../components/LoadingContainer';

import {
  Container,
  Body,
  RedLabel,
  DivTax,
  DivIntegration,
  Card,
  ModalActive,
  ModalCancelIntegration,
  DivCards,
  CardPayType,
  SpanStatus,
  // DivLinks,
  DivPixDiscount,
  DivInstallments,
  DivOtherOptions,
} from './styles';

const creditCardInstallments = [
  {
    id: 1,
    value: '1',
    label: 'Nenhum',
  },
  {
    id: 2,
    value: '2',
    label: 'Até 2 vezes',
  },
  {
    id: 3,
    value: '3',
    label: 'Até 3 vezes',
  },
  {
    id: 4,
    value: '4',
    label: 'Até 4 vezes',
  },
  {
    id: 5,
    value: '5',
    label: 'Até 5 vezes',
  },
  {
    id: 6,
    value: '6',
    label: 'Até 6 vezes',
  },
  {
    id: 7,
    value: '7',
    label: 'Até 7 vezes',
  },
  {
    id: 8,
    value: '8',
    label: 'Até 8 vezes',
  },
  {
    id: 9,
    value: '9',
    label: 'Até 9 vezes',
  },
  {
    id: 10,
    value: '10',
    label: 'Até 10 vezes',
  },
  {
    id: 11,
    value: '11',
    label: 'Até 11 vezes',
  },
  {
    id: 12,
    value: '12',
    label: 'Até 12 vezes',
  },
];

function ConfigurationPac({ handleClickBackButton, setIndexMenu }) {
  const [token, setToken] = useState('');
  const [modalActive, setModalActive] = useState(false);
  const [modalCancelIntegration, setModalCancelIntegration] = useState(false);

  const [checkCreditCard, setCheckCreditCard] = useState(true);
  const [checkBolet, setCheckBolet] = useState(true);
  const [checkPix, setCheckPix] = useState(true);

  const [clientId, setClientId] = useState();
  const [initialLoading, setInitialLoading] = useState(true);
  const [pixDiscount, setPixDiscount] = useState(0);
  const [maxCreditCardInstallments, setMaxCreditCardInstallments] = useState();
  const [pro, setPro] = useState();

  const { username } = useSelector(state => state.user.profile);

  useEffect(() => {
    async function load() {
      try {
        await api.get(`/proplan`).then(response => {
          const userPro = response && response.data;
          setPro(userPro);

          if (pro === 0) {
            window.location.href = 'https://app.offstore.me/paymentmethods';
          }
        });

        const objToken = await api.get('/gettokenmercadopago');
        const { client_secret, client_ID } = objToken.data;
        setClientId(client_ID);

        const tokenMercadoPago = await api.get('/mercadopago');

        if (tokenMercadoPago && tokenMercadoPago.data) {
          setToken(tokenMercadoPago.data && tokenMercadoPago.data.access_token);

          const maxInstallments = creditCardInstallments.find(
            c => c.id === tokenMercadoPago.data.max_credit_card_installments
          );
          setMaxCreditCardInstallments(maxInstallments);

          setCheckCreditCard(
            tokenMercadoPago.data && tokenMercadoPago.data.credit_card
          );
          setCheckBolet(tokenMercadoPago.data && tokenMercadoPago.data.bolet);
          setCheckPix(tokenMercadoPago.data && tokenMercadoPago.data.pix);
          setPixDiscount(
            tokenMercadoPago.data && tokenMercadoPago.data.pix_discount
          );
        }

        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');

        if (
          code &&
          (!tokenMercadoPago.data ||
            (tokenMercadoPago.data && !tokenMercadoPago.data.access_token))
        ) {
          try {
            const response = await axios.post(
              'https://api.mercadopago.com/oauth/token',
              {
                client_secret,
                client_ID,
                grant_type: 'authorization_code',
                code,
                redirect_uri: `${window.location.origin}/redirectmp`,
              },
              {
                headers: {
                  accept: 'application/json',
                  'content-type': 'application/x-www-form-urlencoded',
                },
              }
            );

            if (response && response.data && !response.data.error) {
              await api.post('/mercadopago', {
                access_token: response.data.access_token,
                expiration_token: response.data.expires_in,
                user_id_mercado_pago: response.data.user_id,
                refresh_token: response.data.refresh_token,
                public_key: response.data.public_key,
                key_updated_at: Date.now(),
              });

              setToken(response.data.access_token);

              await api.get('/orderconfigurations').then(async res => {
                if (res && res.data) {
                  await api.put('/orderconfigurations', {
                    show_cpf_cnpj: true,
                  });
                }
              });

              await api.put('/verifypaymentmethods', {
                paymentMethod: 'mercadopago',
                value: true,
              });

              setModalActive(true);
            }
          } catch (err) {
            setInitialLoading(false);
            toast.error(
              'Não foi possível ativar a integração. Entre em contato com a Offstore'
            );
          }
        }
        setInitialLoading(false);
      } catch (err) {
        setInitialLoading(false);
      }
    }

    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleRemoveToken() {
    await api.put('/mercadopago', {
      active: false,
      access_token: null,
      expiration_token: null,
      user_id_mercado_pago: null,
      refresh_token: null,
      public_key: null,
      key_updated_at: null,
    });

    setToken('');
    setModalCancelIntegration(false);
  }

  async function handleBlurDiscountPix(e) {
    try {
      await api.put('/mercadopago', {
        pix_discount: e.target.value,
      });

      toast.success('Alteração salva');
    } catch (err) {
      console.log(err);
    }

    return 0;
  }

  async function handleChangeMaxInstallments(e) {
    try {
      setMaxCreditCardInstallments(e);

      await api.put('/mercadopago', {
        max_credit_card_installments: e.id,
      });
    } catch (err) {
      console.log(err);
    }

    return 0;
  }

  async function onChangeActiveCreditCard(value) {
    if (value === false && !checkBolet && !checkPix) {
      toast.error('Você precisa de pelo menos 1 forma de pagamento');

      return 0;
    }

    setCheckCreditCard(value);

    await api.put('/mercadopago', {
      credit_card: value,
    });

    return 0;
  }

  // async function onChangeActiveBolet(value) {
  //   if (value === false && !checkCreditCard && !checkPix) {
  //     toast.error('Você precisa de pelo menos 1 forma de pagamento');

  //     return 0;
  //   }

  //   setCheckBolet(value);

  //   await api.put('/mercadopago', {
  //     bolet: value,
  //   });

  //   return 0;
  // }

  async function onChangeActivePix(value) {
    if (value === false && !checkCreditCard && !checkBolet) {
      toast.error('Você precisa de pelo menos 1 forma de pagamento');

      return 0;
    }

    setCheckPix(value);

    await api.put('/mercadopago', {
      pix: value,
    });

    return 0;
  }

  function handleClickBack() {
    handleClickBackButton();
  }

  return (
    <Container>
      <LoadingContainer loading={initialLoading} />
      <Header title="Mercado Pago" handleClickBack={handleClickBack} />

      <Body>
        {!token && (
          <RedLabel>
            <span>
              Para fazer a integração você precisa ter uma conta no Mercado
              Pago, caso não tenha,{' '}
              <a
                href="https://mercadopago.com.br"
                target="_blank"
                rel="noopener noreferrer"
              >
                toque aqui
              </a>{' '}
              para criar.
            </span>
          </RedLabel>
        )}

        <DivIntegration first>
          {(token && (
            <>
              <strong>Selecionar formas de pagamento</strong>

              <span>Selecione as formas de pagamento que você irá aceitar</span>
            </>
          )) || (
            <>
              <strong>Integre sua conta do mercado pago</strong>

              <span>
                Toque no botão abaixo para ativar a integração com sua conta do
                Mercado Pago, leva poucos segundos
              </span>

              <a
                href={`https://auth.mercadopago.com.br/authorization?client_id=${clientId}&response_type=code&platform_id=mp&state=${username}&redirect_uri=${window.location.origin}/redirectmp`}
              >
                Ativar integração
              </a>
            </>
          )}
        </DivIntegration>

        {token && (
          <>
            <DivCards>
              <CardPayType enabled={checkCreditCard}>
                <div className="left">
                  <strong>
                    Cartão de crédito{' '}
                    {checkCreditCard && (
                      <SpanStatus color="#2B8FF5">Ativo</SpanStatus>
                    )}
                  </strong>

                  {/* {(checkCreditCard && (
                    <SpanStatus color="#2B8FF5">Ativo</SpanStatus>
                  )) || <SpanStatus color="#AFAFAF">Desativado</SpanStatus>} */}

                  {/* <span>3,89%(Mercado Pago) + 1,75%(Offstore) = 5,64%</span> */}
                  <span>3,99%</span>
                </div>

                <div className="right">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={checkCreditCard}
                      onChange={e => onChangeActiveCreditCard(e.target.checked)}
                    />
                    <span className="slider round" />
                  </label>
                </div>
              </CardPayType>

              <CardPayType enabled={checkPix}>
                <div className="left">
                  <strong>
                    Pix{' '}
                    {checkPix && <SpanStatus color="#2B8FF5">Ativo</SpanStatus>}
                  </strong>

                  {/* {(checkPix && (
                    <SpanStatus color="#2B8FF5">Ativo</SpanStatus>
                  )) || <SpanStatus color="#AFAFAF">Desativado</SpanStatus>} */}

                  <span>0,99%</span>
                </div>

                <div className="right">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={checkPix}
                      onChange={e => onChangeActivePix(e.target.checked)}
                    />
                    <span className="slider round" />
                  </label>
                </div>
              </CardPayType>

              {/* <CardPayType enabled={checkBolet}>
                <div className="left">
                  <strong>
                    Boleto{' '}
                    {checkBolet && (
                      <SpanStatus color="#2B8FF5">Ativo</SpanStatus>
                    )}
                  </strong>

                  <span>R$ 3,49 por boleto pago</span>
                </div>

                <div className="right">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={checkBolet}
                      onChange={e => onChangeActiveBolet(e.target.checked)}
                    />
                    <span className="slider round" />
                  </label>
                </div>
              </CardPayType> */}

              {/* <span className="blue">
                A partir do dia 15/04 a Offstore cobrará 1,75% sobre pagamentos
                feitos via Mercado Pago
              </span> */}

              <span>
                Comissão por venda da Offstore:{' '}
                <span className="blue">1,75%</span>
              </span>

              <Space height="12px" />

              <span>
                As taxas do Mercado Pago apresentadas aqui são referentes ao
                recebimento em 30 dias. As taxas do Mercado Pago podem divergir
                das informações apresentadas aqui, caso eles alterem suas taxas.
              </span>
            </DivCards>

            <DivPixDiscount>
              <strong>Desconto para pagamento via PIX</strong>
              <span>Defina um desconto para pagamentos via PIX</span>

              <DiscountInput
                defaDiscountInputultValue={pixDiscount}
                onChange={e => setPixDiscount(Number(e.target.value))}
                onBlur={handleBlurDiscountPix}
                placeholder="0"
                maxWidth="143px"
                marginTop="8px"
                value={pixDiscount}
              />
            </DivPixDiscount>

            <DivInstallments>
              <strong>Parcelamento sem juros no cartão</strong>
              <span>
                Defina em quantas vezes você quer parcelar sem juros para seu
                cliente.
              </span>

              <Select
                id="selected"
                className="selected"
                placeholder="Selecionar"
                name="tg"
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    borderWidth: '1px',
                    borderColor: state.isFocused ? '#000000' : '#cdcdcd',
                    borderRadius: '8px',
                    boxShadow: 'none',
                    height: '40px',
                    padding: '0 8px 0 16px',
                  }),
                  indicatorSeparator: provided => ({
                    ...provided,
                    background: 'none',
                  }),
                  indicatorsContainer: provided => ({
                    ...provided,
                    padding: '0',
                  }),
                  valueContainer: provided => ({
                    ...provided,
                    padding: '0',
                  }),
                }}
                options={creditCardInstallments}
                value={maxCreditCardInstallments}
                onChange={e => handleChangeMaxInstallments(e)}
              />

              <span>
                Lembre-se que você também precisa configurar o parcelamento sem
                juros no painel do Mercado Pago{' '}
              </span>

              <a
                href="https://www.mercadopago.com.br/costs-section/merchant-svcs/financing/psj/installments"
                target="_blank"
                rel="noreferrer"
              >
                Configurar parcelamento no Mercado Pago
                <svg
                  width="15"
                  height="12"
                  viewBox="0 0 15 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 6L13.8571 6"
                    stroke="#0D85FF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8.85718 1L13.8572 6L8.85718 11"
                    stroke="#0D85FF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </DivInstallments>
          </>
        )}

        {!token && (
          <DivTax>
            <strong>Taxas por venda</strong>
            <span>Confira as taxas abaixo</span>

            <Space height="12px" />

            <Card>
              <div>
                {/* <div>
              <img src={CreditCardIcon} alt="credit card" />
            </div> */}

                <span>Cartão de crédito</span>
              </div>
              <span>3,99%</span>
            </Card>

            <Card>
              <div>
                {/* <div>
              <img src={QrCodeIcon} alt="qrcode" />
            </div> */}

                <span>PIX</span>
              </div>
              <span>0,99%</span>
            </Card>

            {/* <Card disabled>
              <div>
                <span>Boleto bancário</span>
              </div>
              <span>R$ 3,49(Mercado Pago) + R$0,50(Offstore)</span>
            </Card> */}

            {/* <Space height="4px" />

            <span>
              Comissão por venda da Offstore:{' '}
              <span className="blue">1,75%</span>
            </span> */}

            <span>
              As taxas do Mercado Pago apresentadas aqui são referentes ao
              recebimento em 30 dias. As taxas do Mercado Pago podem divergir
              das informações apresentadas aqui, caso eles alterem suas taxas.
            </span>

            <CardCommissions
              paymentMethod="Mercado Pago"
              handleClickButtonSeePlan={() => setIndexMenu(7)}
              isDesktop
            />

            {pro === 1 && !initialLoading && (
              <ShortCardPremiumPlan
                buttonHandleClick={() => setIndexMenu(7)}
                isDesktop
              />
            )}
          </DivTax>
        )}

        {token && (
          <DivOtherOptions>
            <strong>Outras opções</strong>

            <div>
              <a
                href="https://www.mercadopago.com.br/costs-section"
                target="_blank"
                rel="noopener noreferrer"
              >
                Configurar recebimento
              </a>
              <a
                href="https://www.mercadopago.com.br/banking/balance"
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver saldo
              </a>
              <a
                href="https://www.mercadopago.com.br"
                target="_blank"
                rel="noopener noreferrer"
              >
                Acessar Mercado Pago
              </a>
              <a
                href="https://conteudo.mercadopago.com.br/passo-a-passo-cadastre-agora-sua-chave-pix-no-mercado-pago"
                target="_blank"
                rel="noopener noreferrer"
              >
                Cadastrar chave PIX
              </a>
            </div>
          </DivOtherOptions>
        )}

        {/* {token && (
          <DivLinks>
            <strong>Links úteis</strong>

            <a
              href="https://conteudo.mercadopago.com.br/passo-a-passo-cadastre-agora-sua-chave-pix-no-mercado-pago"
              target="_blank"
              rel="noopener noreferrer"
            >
              Cadastrar chave PIX no Mercado Pago{' '}
              <img src={LinkIcon} alt="link" />
            </a>
            <a
              href="https://www.mercadopago.com.br/costs-section"
              target="_blank"
              rel="noopener noreferrer"
            >
              Configure suas taxas <img src={LinkIcon} alt="link" />
            </a>
            <a
              href="https://www.mercadopago.com.br/banking/balance"
              target="_blank"
              rel="noopener noreferrer"
            >
              Consulte seu saldo <img src={LinkIcon} alt="link" />
            </a>
            <a
              href="https://www.mercadopago.com.br/costs-section/psj"
              target="_blank"
              rel="noopener noreferrer"
            >
              Definir parcelamento sem juros <img src={LinkIcon} alt="link" />
            </a>
          </DivLinks>
        )} */}

        <DivIntegration>
          {token && (
            <>
              <strong>Remover integração</strong>

              <span>
                Toque no botão abaixo para remover a integração com sua conta no
                Mercado Pago
              </span>

              <button
                type="button"
                className="remove-token"
                onClick={() => setModalCancelIntegration(true)}
              >
                Remover integração
              </button>
            </>
          )}
        </DivIntegration>
      </Body>

      {modalActive && (
        <ModalActive>
          <div className="container" />
          <div className="div">
            <img src={ActiveMercadoPagoIcon} alt="active" />

            <strong>Parabéns, você já pode receber pagamentos no site!</strong>

            <span>
              Você ativou a integração com o Mercado Pago, e agora seus clientes
              já podem pagar pelas compras diretamente no site.
            </span>

            <button type="button" onClick={handleClickBack}>
              Entendi
            </button>
          </div>
        </ModalActive>
      )}

      {modalCancelIntegration && (
        <ModalCancelIntegration>
          <div
            className="container"
            onClick={() => setModalCancelIntegration(false)}
          />
          <div className="div">
            <strong>Remover integração</strong>
            <span>Tem certeza que deseja remover a integração?</span>

            <button
              type="button"
              className="btn-cancel"
              onClick={handleRemoveToken}
            >
              Remover integração
            </button>
            <button
              type="button"
              onClick={() => setModalCancelIntegration(false)}
            >
              Cancelar
            </button>
          </div>
        </ModalCancelIntegration>
      )}
    </Container>
  );
}

export default ConfigurationPac;
